import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var _require = require('lodash'),
    get = _require.get;

var Alerts = /*#__PURE__*/function () {
  function Alerts(alertsStats) {
    this._totalAlerts = get(alertsStats, 'totalAlerts', null);
    this._alertInTimeRange = get(alertsStats, 'alertInTimeRange', null);
  }
  /** **********************************************
   *  Getters/Setters of raw data
   * ********************************************* */


  _createClass(Alerts, [{
    key: 'totalAlerts',
    get: function get() {
      return this._totalAlerts;
    }
  }, {
    key: 'alertInTimeRange',
    get: function get() {
      return this._alertInTimeRange;
    }
  }]);

  return Alerts;
}();

export { Alerts as default };